import {useState, useEffect } from 'react';
import { useDispatch,useSelector } from "react-redux";
import { visualizerActions, uiActions } from "../../store";

import styles from "./Floorplancard.module.css";

import bedIcon from './assets/bed_Icon.png';
import tubIcon from './assets/tub_Icon.png';
import cropIcon from './assets/crop_Icon.png';
import carIcon from './assets/car_Icon.png';

export default function FloorplanCard({ id, floorplan, defaultScene, beds, baths, sqft, cars }) {
    const dispatch = useDispatch();
    const activeFloorPlanData = useSelector((state) => state.visualizer.activeFloorPlanData);
    const [selectedCard, setselectedCard] = useState();

     useEffect(() => {

        
        if(activeFloorPlanData){
            dispatch(visualizerActions.setActiveCommunity(null));
        }
        

     }, [selectedCard,activeFloorPlanData])

    const handleSelect = () => {
        //clear out any stored package data
        let triggerId = Math.floor(Math.random() * 1000);
        dispatch(visualizerActions.setActivePackage(null));
        dispatch(visualizerActions.setActiveFloorplanFromID(id))
        dispatch(visualizerActions.setActiveFloorplanStepsFromID(id));
        dispatch(uiActions.setSceneModalActive(true));
        setselectedCard(triggerId);

    }

    return (
        <div className={styles.scenes}>
             <div className={styles.cardImg}>
            <img src={defaultScene} alt="Floorplan Exterior" />
            </div>
            <div>
                <h1>{floorplan}</h1>
                <div className={styles.cardSet}>
                    <div className={styles.cardDiv}>
                        <img src={bedIcon} alt="Beds Icon" />
                        <span>{beds}</span>
                        <p>Beds</p>
                    </div>
                    <div className={styles.cardDiv}>
                        <img src={tubIcon} alt="Baths Icon" />
                        <span>{baths}</span>
                        <p>Baths</p>
                    </div>
                    <div className={styles.cardDiv}>
                        <img src={cropIcon} alt="Sqft Icon" />
                        <span>{sqft}</span>
                        <p>SQFT</p>
                    </div>
                    <div className={styles.cardDiv}>
                        <img src={carIcon} alt="Cars Icon" />
                        <span>{cars}</span>
                        <p>Cars</p>
                    </div>
                </div>
            </div>
            <button onClick={handleSelect}>SELECT PLAN</button>
        </div>
    );
}

